export default __webpack_public_path__ + "locales/de/Common.json?hash=4d6d6e4c982965b98b61427c280b0da8";